<ng-container [formGroup]="formgroup">
  <div *ngIf="(isValidatorOn)" id="alertInfoBox" class="alert alert-danger" role="alert">
    {{this.validationErrorText}}
  </div>
  
  <div *ngIf="(ie.CustomizeOptions != null)">
    <div class="custom-ie-bottom-spacing" *ngIf="(ie.CustomizeOptions.DisplayType == 'chart')">
     
      <app-html-chart (notifyListUpdate)="onNotifyListUpdate($event)" [ieListType]="ie"
        [chartList]="ie.CustomDisplayTypes.chart">
      </app-html-chart>
    </div>
    <div class="custom-ie-bottom-spacing" *ngIf="(ie.CustomizeOptions.DisplayType == 'map')">
      <app-html-map [ieListType]="ie"></app-html-map>
    </div>
    <div class="slider-top-spacing custom-ie-bottom-spacing"
      *ngIf="(ie.CustomizeOptions.DisplayType == 'slider')">
      <app-html-slider [ieListType]="ie"></app-html-slider>
    </div>
    <div class="" *ngIf="(ie.CustomizeOptions.DisplayType == 'tree')">
      <app-html-tree [ie]="ie">
      </app-html-tree>
    </div>
  </div>
 
  <div *ngIf="( (ie.CustomizeOptions == null) || (ie.CustomizeOptions != null && ie.CustomizeOptions.DisplayType == null))">
    <div class="table-responsive" *ngIf="(ie.FilterAsHeader)">
      <table class="table table-bordered table-striped table-sortable">
        <thead valign="top">
          <th sort="sort" *ngFor="let filterHeader of gridView.tableForFilter.headers">
            {{filterHeader.Name}}
          </th>
        </thead>

        <tbody>
          <tr class="tr-height" *ngFor="let filterRow of gridView.tableForFilter.rows">
            <td *ngFor="let filterRowItems of filterRow.value">
              <p>
                <small>{{filterRowItems}}</small>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--<button class="btn btn-sm btn-warning" (click)="stopBubbling($event);uxControllerService.openAccessRightEditor(ie,accessRightEditorTemplate)">
                  <i id="button_AccessRight"></i></button> &nbsp;-->
   <!--<small class="text-sm-right">t{{rowItems.replace("00:00:00", "")}}</small>-->
  <!--<div class="container">-->
     <!-- <a  (click)="revertLastEdit()" class="link-secondary">Revert</a>
      <a  (click)="saveAllEdited()" class="link-secondary">&nbsp;&nbsp;Save All</a>
      <a  href="#" class="link-secondary">&nbsp;&nbsp;Revert All</a>-->
      <!--(onColumnsResized)="onColumnResizing($event)"-->
      <!--<span id='dynaEditorIcon' *ngIf="uxControllerService.RTKeyAllowDynaEdit && ie.EntityList!= null && ie.EntityList.RowItems.length>0" class="dynaEditorAllign"> -->
      <span id='dynaEditorIcon' *ngIf="uxControllerService.RTKeyAllowDynaEdit" class="dynaEditorAllign">
        <button class="btn btn-sm btn-warning" (click)="stopBubbling($event);uxControllerService.openDynaEditor(ie,dynaEditorTemplate)">
          <i id="button_DynaEdit"></i></button>
      </span>
      <div  class="grid-border" id="entityList" *ngIf="(ie.EntityList != null && ie.EntityList.RowItems.length > 0); else emptyRowNotification">  
        <angular-slickgrid [gridId]="gridId"
         [columnDefinitions]="columnDefinitions"
         [gridOptions]="gridOptions"
         (onAngularGridCreated)="angularGridReady($event.detail)"
         [dataset]="dataset"
         (onCellChange)="onCellChanged($event.detail.eventData, $event.detail.args)"
         (onColumnsResized)="onColumnResizing($event)"
         (onGridStateChanged)="gridStateChanged($event)"
         (onHeaderClick)="onColClicked($event.detail)"
         (onDblClick)="onRowDoubleClicked($event.detail.eventData, $event.detail.args)"
         (onClick)="onRowSingleClicked($event.detail.eventData, $event.detail.args)"
         (onSelectedRowsChanged)="onRowMultipleClicked($event.detail.eventData, $event.detail.args)"
         (onValidationError)="onValidationError($event.detail.eventData, $event.detail.args)"
         >
       </angular-slickgrid>
       </div>
   
    <div *ngIf="(!ie.FilterAsHeader) " class="col-md-12 text-center ">
      <button class="btn btn-warning btn-sm btn-spacing " *ngFor="let
          filter of ie.Filters " type='button' (click)="filteredBy(filter,ie) ">{{filter.Name}}</button>
    </div>

    <div *ngIf="ie.EntityList!= null && ie.EntityList.RowItems.length>0" class="slick-pagination">
      <div class="slick-pagination-nav">
          <nav aria-label="Page navigation">
              <ul class="pagination">
                  <li class="page-item" [ngClass]="ie.Attributes.ActivePage === 1 ? 'disabled' : ''">
                      <a class="page-link icon-seek-first fa fa-angle-double-left"
                      aria-label="First" (click)="changeToFirstPage($event)"> </a>
                  </li>
                  <li class="page-item" [ngClass]="ie.Attributes.ActivePage === 1 ? 'disabled' : ''">
                      <a class="page-link icon-seek-prev fa fa-angle-left"
                      aria-label="Previous" (click)="changeToPreviousPage($event)"> </a>
                  </li>
              </ul>
          </nav>
          <nav>
            <div>
               <span [translate]="'PAGE'" >&nbsp;</span>
               <input #ap id="activePage" class="pager-value" type="text" value="{{ie.Attributes.ActivePage}}" size="1" (input)="pageValidator(ap.value)" (change)="changeToCurrentPage($event)" style="text-align: center;">
               <span [translate]="'OF'">&nbsp;/</span><span>&nbsp;{{pageCount}}&nbsp;</span>
            </div>
          </nav>
          <nav aria-label="Page navigation">
              <ul class="pagination">
                  <li class="page-item"
                      [ngClass]="ie.Attributes.ActivePage === ie.Attributes.PageCount ? 'disabled' : ''"><a
                      class="page-link icon-seek-next text-center fa fa-angle-right"
                      aria-label="Next" (click)="changeToNextPage($event)"> </a></li>
                  <li class="page-item"
                      [ngClass]="ie.Attributes.ActivePage === ie.Attributes.PageCount ? 'disabled' : ''"><a
                      class="page-link icon-seek-end fa fa-angle-double-right"
                      aria-label="Last" (click)="changeToLastPage($event)"> </a></li>
              </ul>
          </nav>
          <nav>
              <ul class="pagination">
                  <li class="">
                      <span [hidden]="!processing" class="page-spin">
                          <i class="fa fa-refresh fa-spin fa-lg fa-fw"></i>
                      </span>
                  </li>
              </ul>
          </nav>
      </div>
      <span class="pager-text"> {{paginationText}} </span>
    </div>
  </div>
  <div>
    
  </div>
  <ng-template #emptyRowNotification>
    <div class="alert alert-info margin-bottom-30">
      <strong>{{emptyRowNotifyMessage}}</strong>
    </div>
  </ng-template>
</ng-container>